import MaterialTreeView from '@mui/lab/TreeView';
import { TopBar } from 'shared-ui';
import styled from 'styled-components';

export const TopBarWrapper = styled(TopBar)`
  padding-bottom: 12px;
`;

export const ToolbarWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  gap: 16px;

  padding-bottom: 12px;
`;

export const TreeView = styled(MaterialTreeView)`
  height: auto;
  flex-grow: 1;
  max-width: auto;
  overflow-y: auto;

  && > li > div {
    padding-left: 0;
    display: grid;
    grid-template-columns: 70px 1fr;

    & .MuiTreeItem-iconContainer {
      width: 100%;
      margin: 0;
    }
  }
`;
